import { useDispatch } from 'react-redux'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import { actions } from 'src/features/stock-management/StockManagementState'

export default ({
  barcode, modelId, showModal, setShowModal, setSelected,
}) => {
  const dispatch = useDispatch()

  const confirmDeleteBarcode = () => {
    setShowModal(false)
    dispatch(actions.deleteBarcode({ barcode, modelId }))
    setSelected(false)
  }

  return (
    <ConfirmOrRejectModal
      show={showModal}
      title='Excluir Barcode'
      description={`Você tem certeza que deseja excluir o código de barras ${barcode}?`}
      onConfirm={confirmDeleteBarcode}
      onReject={() => setShowModal(false)}
      onClose={() => setShowModal(false)}
    />
  )
}
